import { Pipe, PipeTransform } from '@angular/core';
import { ProviderSettingsService } from '@core/services';

@Pipe({
  name: 'mwstUppercase',
  pure: false
})
export class MwstUppercasePipe implements PipeTransform {
  constructor(
    private providerSettingsService: ProviderSettingsService,
  ) {}

  transform(query: string | null | undefined): string | null | undefined {
    if (query && this.providerSettingsService.providerSettings.value?.general_data?.country_code === "CH") {
      return query.replaceAll('MwSt.', 'MWST.');
    }
    return query;
  }
}
